import Badge from "../components/Badge";
import BaseAlert from "../components/BaseAlert";
import BaseButton from "../components/BaseButton";
import BaseCheckbox from "../components/BaseCheckbox";
import BaseInput from "../components/BaseInput";
import BasePagination from "../components/BasePagination";
import BaseProgress from "../components/BaseProgress";
import BaseRadio from "../components/BaseRadio";
import BaseSlider from "../components/BaseSlider";
import BaseSwitch from "../components/BaseSwitch";
import Card from "../components/Card";
import Icon from "../components/Icon";
import BingoHalls from "../components/BingoHalls"
import MyBingoHalls from "../components/MyBingohalls"
import BingoPage from "../components/BingoPage"
import ChooseBingoHalls from "../components/ChooseBingohalls"
import HallOpenStatus from "../components/HallOpenStatus"

export default {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSlider.name, BaseSlider);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(Icon.name, Icon);
    Vue.component(BingoHalls.name, BingoHalls);
    Vue.component(MyBingoHalls.name, MyBingoHalls);
    Vue.component(BingoPage.name, BingoPage);
    Vue.component(ChooseBingoHalls.name, ChooseBingoHalls);
    Vue.component(HallOpenStatus.name, HallOpenStatus);
  }
};
